var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-spin",
    { attrs: { size: "large", spinning: _vm.loading } },
    [
      _c(
        "common-layout",
        [
          _c("div", { staticClass: "main-login" }, [
            !_vm.isMobile
              ? _c("div", { staticClass: "left" }, [
                  _c("div", { staticClass: "left-wrap" }, [
                    _c(
                      "div",
                      { staticClass: "header" },
                      [
                        _c("svg-icon", {
                          staticClass: "logo",
                          staticStyle: {
                            width: "309px",
                            height: "44px",
                            background: "none",
                          },
                          attrs: { iconClass: "login" },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "left-img" },
                      [
                        _c(
                          "a-carousel",
                          { attrs: { autoplay: "", dotsClass: "dots" } },
                          [
                            _c("div", [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/img/login1.png"),
                                },
                              }),
                            ]),
                            _c("div", [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/img/login2.png"),
                                },
                              }),
                            ]),
                            _c("div", [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/img/login3.png"),
                                },
                              }),
                            ]),
                            _c("div", [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/img/login4.png"),
                                },
                              }),
                            ]),
                            _c("div", [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/img/login5.png"),
                                },
                              }),
                            ]),
                            _c("div", [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/img/login6.png"),
                                },
                              }),
                            ]),
                            _c("div", [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/img/login7.png"),
                                },
                              }),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ])
              : _vm._e(),
            _c("div", { staticClass: "right" }, [
              !_vm.loinFail
                ? _c("div", { staticClass: "login" }, [
                    _c("div", { staticClass: "title", class: [_vm.lang] }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.isSignUp
                              ? _vm.$t("StartTrial")
                              : _vm.$t("SignUpTitle")
                          ) +
                          " "
                      ),
                    ]),
                    _c("div", { staticClass: "subTitle", class: [_vm.lang] }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.isSignUp
                              ? _vm.$t("try10DaysFree")
                              : _vm.$t("SignUpSubTitle")
                          ) +
                          " "
                      ),
                    ]),
                    _c("div", { staticClass: "auth" }, [
                      _c(
                        "ul",
                        [
                          _c(
                            "a-tooltip",
                            {
                              attrs: {
                                placement: "rightTop",
                                overlayClassName: "sign-up-tooltip",
                              },
                            },
                            [
                              _vm.isSignUp && !_vm.isMobile
                                ? _c("template", { slot: "title" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("loginBtnHoverTip")) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                              _c(
                                "li",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.author("google-oauth2")
                                    },
                                  },
                                },
                                [
                                  _c("svg-icon", {
                                    attrs: { iconClass: "google" },
                                  }),
                                  _c("span", { class: [_vm.lang] }, [
                                    _vm._v(_vm._s(_vm.$t("SigninwithGoogle"))),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                          _c(
                            "a-tooltip",
                            {
                              attrs: {
                                placement: "rightTop",
                                overlayClassName: "sign-up-tooltip",
                              },
                            },
                            [
                              _vm.isSignUp && !_vm.isMobile
                                ? _c("template", { slot: "title" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("loginBtnHoverTip")) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                              _c(
                                "li",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.author("linkedin")
                                    },
                                  },
                                },
                                [
                                  _c("svg-icon", {
                                    attrs: { iconClass: "linkin" },
                                  }),
                                  _c("span", { class: [_vm.lang] }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("SigninwithLinkedIn"))
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                          _c(
                            "a-tooltip",
                            {
                              attrs: {
                                placement: "rightTop",
                                overlayClassName: "sign-up-tooltip",
                              },
                            },
                            [
                              _vm.isSignUp && !_vm.isMobile
                                ? _c("template", { slot: "title" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("loginBtnHoverTip")) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                              _c(
                                "li",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.author("facebook")
                                    },
                                  },
                                },
                                [
                                  _c("svg-icon", {
                                    attrs: { iconClass: "facebook" },
                                  }),
                                  _c("span", { class: [_vm.lang] }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("SigninwithFacebook"))
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "orline" }, [
                        _c("span", [_vm._v(_vm._s(_vm.$t("useEmail")))]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "wrapForm" },
                        [
                          _c(
                            "a-form",
                            {
                              attrs: {
                                layout: "vertical",
                                form: _vm.form,
                                size: "large",
                              },
                            },
                            [
                              _c("div", { staticClass: "form-label" }, [
                                _vm._v(_vm._s(_vm.$t("Email"))),
                              ]),
                              _c(
                                "a-form-item",
                                {
                                  class: [_vm.lang],
                                  attrs: {
                                    "validate-status": _vm.userNameError()
                                      ? "error"
                                      : "",
                                    help: _vm.userNameError() || "",
                                  },
                                },
                                [
                                  _c(
                                    "a-input",
                                    {
                                      directives: [
                                        {
                                          name: "decorator",
                                          rawName: "v-decorator",
                                          value: [
                                            "userName",
                                            {
                                              trigger: "blur",
                                              rules: [
                                                {
                                                  required: true,
                                                  validator: function (
                                                    rule,
                                                    value,
                                                    callback
                                                  ) {
                                                    let reg =
                                                      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                                                    if (
                                                      !value ||
                                                      !value.trim("") ||
                                                      !reg.test(value)
                                                    ) {
                                                      // callback($t('rightAccount'));
                                                      callback(
                                                        _vm.$t("rightEmail")
                                                      )
                                                      return
                                                    }
                                                    callback()
                                                  },
                                                },
                                              ],
                                            },
                                          ],
                                          expression:
                                            "[\n                    'userName',\n                    {\n                      trigger: 'blur',\n                      rules: [\n                        {\n                          required: true,\n                          validator: function (rule, value, callback) {\n                            let reg =\n                              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$/;\n                            if (\n                              !value ||\n                              !value.trim('') ||\n                              !reg.test(value)\n                            ) {\n                              // callback($t('rightAccount'));\n                              callback($t('rightEmail'));\n                              return;\n                            }\n                            callback();\n                          },\n                        },\n                      ],\n                    },\n                  ]",
                                        },
                                      ],
                                      attrs: { placeholder: _vm.$t("Email") },
                                    },
                                    [
                                      _c("a-icon", {
                                        staticStyle: {
                                          color: "rgba(0, 0, 0, 0.25)",
                                        },
                                        attrs: { slot: "prefix", type: "mail" },
                                        slot: "prefix",
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "form-label" }, [
                                _vm._v(_vm._s(_vm.$t("Password"))),
                              ]),
                              _c(
                                "a-form-item",
                                {
                                  class: [_vm.lang],
                                  attrs: {
                                    "validate-status": _vm.passwordError()
                                      ? "error"
                                      : "",
                                    help: _vm.passwordError() || "",
                                  },
                                },
                                [
                                  _c(
                                    "a-input-password",
                                    {
                                      directives: [
                                        {
                                          name: "decorator",
                                          rawName: "v-decorator",
                                          value: [
                                            "password",
                                            {
                                              trigger: ["blur", "change"],
                                              rules: [
                                                {
                                                  required: true,
                                                  validator: function (
                                                    rule,
                                                    value,
                                                    callback
                                                  ) {
                                                    // 检查密码长度是否少于 8 个字符
                                                    if (value.length < 8) {
                                                      callback(
                                                        _vm.$t("charactersDes")
                                                      )
                                                      return
                                                    }

                                                    // 检查是否包含大写字母
                                                    if (!/[A-Z]/.test(value)) {
                                                      callback(
                                                        _vm.$t(
                                                          "uppercaseCharacter"
                                                        )
                                                      )
                                                      return
                                                    }

                                                    // 检查是否包含小写字母
                                                    if (!/[a-z]/.test(value)) {
                                                      callback(
                                                        _vm.$t(
                                                          "lowercaseCharacter"
                                                        )
                                                      )
                                                      return
                                                    }

                                                    // 检查是否包含数字
                                                    if (!/[0-9]/.test(value)) {
                                                      callback(
                                                        _vm.$t("digitRequired")
                                                      )
                                                      return
                                                    }
                                                    // 检查是否包含特殊字符
                                                    if (!_vm.reg.test(value)) {
                                                      callback(
                                                        _vm.$t(
                                                          "specialCharacter"
                                                        )
                                                      )
                                                      return
                                                    }
                                                    callback()
                                                  },
                                                },
                                              ],
                                            },
                                          ],
                                          expression:
                                            "[\n                    'password',\n                    {\n                      trigger: ['blur', 'change'],\n                      rules: [\n                        {\n                          required: true,\n                          validator: function (rule, value, callback) {\n                            // 检查密码长度是否少于 8 个字符\n                            if (value.length < 8) {\n                              callback($t('charactersDes'));\n                              return;\n                            }\n\n                            // 检查是否包含大写字母\n                            if (!/[A-Z]/.test(value)) {\n                              callback($t('uppercaseCharacter'));\n                              return;\n                            }\n\n                            // 检查是否包含小写字母\n                            if (!/[a-z]/.test(value)) {\n                              callback($t('lowercaseCharacter'));\n                              return;\n                            }\n\n                            // 检查是否包含数字\n                            if (!/[0-9]/.test(value)) {\n                              callback($t('digitRequired'));\n                              return;\n                            }\n                            // 检查是否包含特殊字符\n                            if (!reg.test(value)) {\n                              callback($t('specialCharacter'));\n                              return;\n                            }\n                            callback();\n                          },\n                        },\n                      ],\n                    },\n                  ]",
                                        },
                                      ],
                                      attrs: {
                                        placeholder: _vm.$t("Password"),
                                      },
                                    },
                                    [
                                      _c("a-icon", {
                                        staticStyle: {
                                          color: "rgba(0, 0, 0, 0.25)",
                                        },
                                        attrs: { slot: "prefix", type: "lock" },
                                        slot: "prefix",
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("div"),
                                ],
                                1
                              ),
                              !_vm.isSignUp
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "text-align": "left",
                                        "padding-bottom": "10px",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "forgetSkip",
                                          on: { click: _vm.resetPwd },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("ForgotPassword"))
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "a-form-item",
                                [
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: { width: "60%" },
                                      attrs: {
                                        type: "primary",
                                        "html-type": "submit",
                                        disabled:
                                          _vm.hasErrors(
                                            _vm.form.getFieldsError()
                                          ) || !_vm.haveFormValue()
                                            ? true
                                            : false,
                                      },
                                      on: { click: _vm.onSubmit },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.isSignUp
                                              ? _vm.$t("createAaccount")
                                              : _vm.$t("LOGIN")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm.isSignUp
                      ? _c("div", { staticClass: "sign-up-tip" }, [
                          _vm._v(" " + _vm._s(_vm.$t("loginTip"))),
                          _c(
                            "span",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.changeSignUp()
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("loginTipBtn")))]
                          ),
                        ])
                      : _vm._e(),
                    !_vm.isSignUp
                      ? _c("div", { staticClass: "sign-up-tip" }, [
                          _vm._v(" " + _vm._s(_vm.$t("createAaccount"))),
                          _c(
                            "span",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.tabRegister()
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("loginTipBtn")))]
                          ),
                        ])
                      : _vm._e(),
                    _vm.isMobile
                      ? _c("div", { staticClass: "mobileTips" }, [
                          _vm._v(" " + _vm._s(_vm.$t("mobileTips")) + " "),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm.loinFail
                ? _c("div", { staticClass: "fail" }, [
                    _c(
                      "div",
                      { staticClass: "error" },
                      [
                        _c("svg-icon", {
                          staticClass: "loginError",
                          attrs: { iconClass: "loginError" },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "login-text", class: [_vm.lang] },
                      [_vm._v(" " + _vm._s(_vm.$t("Loginfailed")) + " ")]
                    ),
                    _vm.loginInfo.msg
                      ? _c(
                          "div",
                          { staticClass: "eror-code", class: [_vm.lang] },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("Errorcode")) +
                                "：" +
                                _vm._s(_vm.loginInfo.msg) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.showError
                      ? _c(
                          "div",
                          { staticClass: "eror-code", class: [_vm.lang] },
                          [_vm._v(" " + _vm._s(_vm.$t("authorization")) + " ")]
                        )
                      : _vm._e(),
                    _c("div", { staticClass: "retry", class: [_vm.lang] }, [
                      _vm._v(_vm._s(_vm.$t("Youcantry"))),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "btn relogin",
                        class: [_vm.lang],
                        on: { click: _vm.reLogin },
                      },
                      [
                        _c("svg-icon", {
                          staticClass: "icon",
                          attrs: { iconClass: "restart-line" },
                        }),
                        _vm._v(_vm._s(_vm.$t("Logagain")) + " "),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "btn concatus" }, [
                      _c(
                        "a",
                        {
                          class: [_vm.lang],
                          attrs: {
                            href: "https://tawk.to/chat/67626c9aaf5bfec1dbddbfc4/1ifc7gf7c",
                            target: "_blank",
                          },
                        },
                        [
                          _c("svg-icon", {
                            staticClass: "icon",
                            attrs: { iconClass: "concat" },
                          }),
                          _vm._v(_vm._s(_vm.$t("Emailus"))),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "wrap-code" }, [
                      _c("div", { staticClass: "qrcode" }, [
                        _c("img", {
                          attrs: {
                            src: "https://u-img.strategybrain.ca/images/static/linkedIn.jpg",
                          },
                        }),
                        _c("div", { staticClass: "text" }, [
                          _c("span", [_vm._v("Linkedln")]),
                        ]),
                      ]),
                      _c("div", { staticClass: "qrcode" }, [
                        _c("img", {
                          attrs: {
                            src: "https://u-img.strategybrain.ca/images/static/whatsapp.jpg",
                          },
                        }),
                        _c("div", { staticClass: "text" }, [
                          _c("span", [_vm._v("Whats App")]),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "qus", class: [_vm.lang] }, [
                      _vm._v(_vm._s(_vm.$t("problem"))),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ]),
          _c(
            "a-modal",
            {
              attrs: {
                maskClosable: false,
                title: _vm.$t("verificationCode"),
                "on-ok": "handleOk",
              },
              on: { cancel: _vm.handleCancel },
              model: {
                value: _vm.showModal,
                callback: function ($$v) {
                  _vm.showModal = $$v
                },
                expression: "showModal",
              },
            },
            [
              _c("template", { slot: "footer" }, [
                _c(
                  "div",
                  { staticStyle: { "text-align": "center" } },
                  [
                    _c(
                      "a-button",
                      {
                        key: "submit",
                        attrs: {
                          type: "primary",
                          disabled:
                            _vm.hasErrors(_vm.form2.getFieldsError()) ||
                            !_vm.haveForm2Value()
                              ? true
                              : false,
                        },
                        on: { click: _vm.handleOk },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("Submit")) + " ")]
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                { staticClass: "wrapForm2" },
                [
                  _c("p", { class: [_vm.lang] }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm
                            .$t("digitVerification")
                            .replace("xxxxx", _vm.formData.userName)
                        ) +
                        " "
                    ),
                  ]),
                  _c(
                    "a-form",
                    {
                      attrs: {
                        layout: "vertical",
                        form: _vm.form2,
                        size: "large",
                      },
                    },
                    [
                      _c(
                        "a-form-item",
                        {
                          staticClass: "codeForm",
                          attrs: {
                            "validate-status": _vm.codeError() ? "error" : "",
                            help: _vm.codeError() || "",
                          },
                        },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "verificationCode",
                                  {
                                    trigger: ["blur", "change"],
                                    rules: [
                                      {
                                        required: true,
                                        validator: function (
                                          rule,
                                          value,
                                          callback
                                        ) {
                                          let reg = /^[0-9]{6}$/
                                          if (
                                            !value ||
                                            !value.trim("") ||
                                            !reg.test(value)
                                          ) {
                                            callback(_vm.$t("invalidCode"))
                                            return
                                          }
                                          callback()
                                        },
                                      },
                                    ],
                                  },
                                ],
                                expression:
                                  "[\n              'verificationCode',\n              {\n                trigger: ['blur', 'change'],\n                rules: [\n                  {\n                    required: true,\n                    validator: function (rule, value, callback) {\n                      let reg = /^[0-9]{6}$/;\n                      if (!value || !value.trim('') || !reg.test(value)) {\n                        callback($t('invalidCode'));\n                        return;\n                      }\n                      callback();\n                    },\n                  },\n                ],\n              },\n            ]",
                              },
                            ],
                          }),
                          _vm.countdown > 0
                            ? _c("span", { staticClass: "time" }, [
                                _vm._v(" " + _vm._s(_vm.countdown + "s") + " "),
                              ])
                            : _c(
                                "span",
                                {
                                  staticClass: "time time2",
                                  on: { click: _vm.sendVerificationCode },
                                },
                                [_vm._v(" " + _vm._s(_vm.$t("Resend")) + " ")]
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.visiable,
                  expression: "visiable",
                },
              ],
              staticClass: "mask",
            },
            [
              _c("div", { staticClass: "dialog" }, [
                _c("div", { staticClass: "loading" }, [
                  _c("img", {
                    attrs: { src: require("@/assets/img/login_loading.gif") },
                  }),
                ]),
                _c("div", { staticClass: "text", class: [_vm.lang] }, [
                  _vm._v(_vm._s(_vm.$t("loadingSpace")) + ".."),
                ]),
                _c(
                  "div",
                  { staticClass: "slide-wrap" },
                  [
                    _c(
                      "a-carousel",
                      { attrs: { autoplay: "", dotsClass: "dots" } },
                      [
                        _c("div", { staticClass: "dtext", class: [_vm.lang] }, [
                          _vm._v(" " + _vm._s(_vm.$t("Afterlogging")) + " "),
                        ]),
                        _c("div", { staticClass: "dtext", class: [_vm.lang] }, [
                          _vm._v(" " + _vm._s(_vm.$t("Whencreating")) + " "),
                        ]),
                        _c("div", { staticClass: "dtext", class: [_vm.lang] }, [
                          _vm._v(" " + _vm._s(_vm.$t("Youcancreate")) + " "),
                        ]),
                        _c("div", { staticClass: "dtext", class: [_vm.lang] }, [
                          _vm._v(" " + _vm._s(_vm.$t("Settingsearch")) + " "),
                        ]),
                        _c("div", { staticClass: "dtext", class: [_vm.lang] }, [
                          _vm._v(" " + _vm._s(_vm.$t("Themore")) + " "),
                        ]),
                        _c("div", { staticClass: "dtext", class: [_vm.lang] }, [
                          _vm._v(" " + _vm._s(_vm.$t("Enteras")) + " "),
                        ]),
                        _c("div", { staticClass: "dtext", class: [_vm.lang] }, [
                          _vm._v(" " + _vm._s(_vm.$t("ForLinkedIn")) + " "),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }